import { render, staticRenderFns } from "./edit.form.vue?vue&type=template&id=18b568f7&scoped=true"
import script from "./edit.form.vue?vue&type=script&lang=js"
export * from "./edit.form.vue?vue&type=script&lang=js"
import style0 from "./edit.form.vue?vue&type=style&index=0&id=18b568f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b568f7",
  null
  
)

export default component.exports